import { render, staticRenderFns } from "./NewOverrideEvent.vue?vue&type=template&id=4dc6583b&scoped=true&"
import script from "./NewOverrideEvent.vue?vue&type=script&lang=js&"
export * from "./NewOverrideEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6583b",
  null
  
)

export default component.exports